
import { Link } from "react-router-dom";
import RevealOnScroll from "@/components/ui/RevealOnScroll";

const steps = [
  {
    n: "01",
    title: "List",
    copy: "Snap a few photos and describe your item in minutes.",
    image: "/images/steps/step-list.webp",
  },
  {
    n: "02",
    title: "Get Approved",
    copy: "Our team reviews every listing before it goes live.",
    image: "/images/steps/step-approved.webp",
  },
  {
    n: "03",
    title: "Sell",
    copy: "Your item joins the Multiverse for collectors to discover.",
    image: "/images/steps/step-sell.webp",
  },
  {
    n: "04",
    title: "Ship",
    copy: "Pack it up and send it to its next home.",
    image: "/images/steps/step-ship.webp",
  },
];

export default function SellSection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden border-y border-cyan-100/10">
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(70% 60% at 80% 20%, rgba(155,62,255,0.28) 0%, transparent 55%), radial-gradient(60% 50% at 10% 80%, rgba(0,159,255,0.22) 0%, transparent 55%), #07183d",
        }}
      />
      <div className="nm-container relative">
        <RevealOnScroll>
          <div className="nm-panel relative mb-16 overflow-hidden rounded-[2rem] aspect-[4/5] md:aspect-[3/1] min-h-[220px]">
            <picture className="absolute inset-0 block h-full w-full">
              <source media="(min-width: 768px)" srcSet="/images/hero/sell-hero.webp" />
              <img src="/images/hero/sell-mobile-v2.webp" alt="A masked multiverse seller photographing, listing, packing and shipping a collectible" className="h-full w-full object-cover" />
            </picture>
            <div className="absolute inset-0 bg-gradient-to-r from-[#051537]/90 via-[#061d47]/25 to-transparent" />
            <div className="relative flex h-full max-w-md flex-col justify-center p-8 md:p-12">
              <span className="nm-kicker">From shelf to new home</span>
              <p className="mt-4 font-display text-2xl md:text-4xl font-black leading-tight text-white">YOUR COLLECTION HAS ANOTHER ADVENTURE IN IT.</p>
            </div>
          </div>
        </RevealOnScroll>
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <RevealOnScroll>
            <span className="nm-kicker">Sell Your Stuff</span>
            <h2 className="mt-5 font-display text-4xl md:text-5xl font-black text-white leading-[.94] tracking-[-.04em]">
              GOT SOMETHING
              <br />
              WORTH COLLECTING?
            </h2>
            <p className="mt-5 text-[var(--nm-ink-muted)] max-w-sm">
              Turn the stuff sitting on your shelf into someone else&apos;s
              next favourite find.
            </p>
            <Link
              to="/sell"
              className="nm-btn-primary mt-8"
            >
              START SELLING
            </Link>
          </RevealOnScroll>

          <div className="grid grid-cols-2 gap-x-8 gap-y-12">
            {steps.map((s, i) => (
              <RevealOnScroll key={s.n} delay={i * 0.1}>
                <div className="w-16 h-16 rounded-2xl overflow-hidden border border-yellow-200/30 bg-white/5 shadow-[0_12px_24px_rgba(0,12,45,.35)]">
                  <img
                    src={s.image}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="mt-3 block font-display text-sm font-black text-[var(--nm-gold)]">
                  {s.n}
                </span>
                <h3 className="mt-1 font-display text-xl font-black text-white">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-[var(--nm-ink-muted)]">{s.copy}</p>
              </RevealOnScroll>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
